import React, { useState } from "react";
import logo from "../utils/images/logo.png";
import "../output.css";
import MenuIcon from "@mui/icons-material/Menu"; // MUI Icon for Hamburger Menu
import CloseIcon from "@mui/icons-material/Close"; // MUI Icon for Close Menu

const Navbar = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isCompanyMenuOpen, setIsCompanyMenuOpen] = useState(false);

    const toggleMenu = () => {
        setIsMenuOpen((prev) => !prev);
    };

    const toggleCompanyMenu = () => {
        setIsCompanyMenuOpen((prev) => !prev);
    };

    return (
        <nav className="flex flex-row items-center justify-between p-4 mx-5 bg-white">
            {/* Logo Section */}
            <div className="flex items-center">
                <img src={logo} alt="Logo" className="h-10 mr-2" />
                <span className="text-lg font-bold text-blue-900">मेरा समाज</span>
            </div>

            {/* Desktop Menu */}
            <ul className="hidden md:flex flex-row gap-5 list-none m-0 p-0">
                <li><a href="#features" className="text-base text-gray-800 transition-colors duration-300 hover:text-blue-700">हमारे ऐप की विशेषताएं</a></li>
                <li><a href="#promo" className="text-base text-gray-800 transition-colors duration-300 hover:text-blue-700">प्रचार वीडियो</a></li>
                <li><a href="#screenshots" className="text-base text-gray-800 transition-colors duration-300 hover:text-blue-700">ऐप के स्क्रीनशॉट</a></li>
                <li><a href="#download" className="text-base text-gray-800 transition-colors duration-300 hover:text-blue-700">ऐप डाउनलोड करें</a></li>
                <li><a href="#faq" className="text-base text-gray-800 transition-colors duration-300 hover:text-blue-700">FAQ</a></li>

                {/* Company Dropdown */}
                <li className="relative">
                    <button
                        className="text-base text-gray-800 transition-colors duration-300 hover:text-blue-700"
                        onClick={toggleCompanyMenu}
                    >
                        Company
                    </button>
                    {isCompanyMenuOpen && (
                        <ul className="absolute top-8 left-0 bg-white shadow-md rounded-md p-4 flex flex-col gap-2 list-none">
                            <li><a href="/termsAndCondition" target="_blank" className="text-base text-gray-800 transition-colors duration-300 hover:text-blue-700">Terms and Conditions</a></li>
                            <li><a href="/privacyPolicy" target="_blank" className="text-base text-gray-800 transition-colors duration-300 hover:text-blue-700">Privacy Policy</a></li>
                            <li><a href="/refundPolicy" target="_blank" className="text-base text-gray-800 transition-colors duration-300 hover:text-blue-700">Refund Policy</a></li>
                            <li><a href="#contact" className="text-base text-gray-800 transition-colors duration-300 hover:text-blue-700">संपर्क करें</a></li>
                        </ul>
                    )}
                </li>
            </ul>

            {/* Mobile Menu Button */}
            <button
                className="block md:hidden text-gray-800"
                onClick={toggleMenu}
            >
                {isMenuOpen ? (
                    <CloseIcon className="h-8 w-8" />
                ) : (
                    <MenuIcon className="h-8 w-8" />
                )}
            </button>

            {/* Mobile Menu */}
            {isMenuOpen && (
                <ul className="absolute top-16 right-4 bg-white shadow-md rounded-md p-4 flex flex-col gap-3 list-none md:hidden z-10">
                    <li><a href="#features" className="text-base text-gray-800 transition-colors duration-300 hover:text-blue-700" onClick={toggleMenu}>हमारे ऐप की विशेषताएं</a></li>
                    <li><a href="#promo" className="text-base text-gray-800 transition-colors duration-300 hover:text-blue-700" onClick={toggleMenu}>प्रचार वीडियो</a></li>
                    <li><a href="#screenshots" className="text-base text-gray-800 transition-colors duration-300 hover:text-blue-700" onClick={toggleMenu}>ऐप के स्क्रीनशॉट</a></li>
                    <li><a href="#download" className="text-base text-gray-800 transition-colors duration-300 hover:text-blue-700" onClick={toggleMenu}>ऐप डाउनलोड करें</a></li>
                    <li><a href="#faq" className="text-base text-gray-800 transition-colors duration-300 hover:text-blue-700" onClick={toggleMenu}>FAQ</a></li>

                    {/* Mobile Company Dropdown */}
                    <li className="relative">
                        <button
                            className="text-base text-gray-800 transition-colors duration-300 hover:text-blue-700"
                            onClick={toggleCompanyMenu}
                        >
                            Company
                        </button>
                        {isCompanyMenuOpen && (
                            <ul className="absolute top-8 left-0 bg-white shadow-md rounded-md p-4 flex flex-col gap-2 list-none">
                                <li><a href="/termsAndCondition" target="_blank" className="text-base text-gray-800 transition-colors duration-300 hover:text-blue-700" onClick={toggleMenu}>Terms and Conditions</a></li>
                                <li><a href="/privacyPolicy" target="_blank" className="text-base text-gray-800 transition-colors duration-300 hover:text-blue-700" onClick={toggleMenu}>Privacy Policy</a></li>
                                <li><a href="/refundPolicy" target="_blank" className="text-base text-gray-800 transition-colors duration-300 hover:text-blue-700" onClick={toggleMenu}>Refund Policy</a></li>
                                <li><a href="#contact" className="text-base text-gray-800 transition-colors duration-300 hover:text-blue-700" onClick={toggleMenu}>संपर्क करें</a></li>
                            </ul>
                        )}
                    </li>
                </ul>
            )}
        </nav>
    );
};

export default Navbar;
